import axiosInstance from './axios.config';

export const publicService = {
  async getAvailableProjects() {
    try {
      const response = await axiosInstance.get('/public/available-projects');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async register(userData) {
    try {
      const response = await axiosInstance.post('/public/register', userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}; 